import { useContext, useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { Navigate,useNavigate } from 'react-router-dom';

import { AuthApi } from '@/API/authApi/AuthAPI';
import { endpoints } from '@/API/endpoints';
import { AuthContext } from '@/context/AuthContext';
import { AuthFormContext } from '@/context/AuthFormContext';
import Form from '@/forms/components/form';
import { ApiDataType, FormDataType } from '@/types';

import classes from './AuthConfirmCode.module.scss';

const AuthConfirmCode = () => {
	const navigate = useNavigate();

	const { isAuth } = useContext(AuthContext);
	const { user, setToken } = useContext(AuthFormContext);

	const [isBtnDisabled, setIsBtnDisabled] = useState(true);
	const [isShowTitle, setIsShowTitle] = useState(false);
	const [countdown, setCountdown] = useState(0);
	const [resDataAfterSubmit, setResDataAfterSubmit] = useState<ApiDataType | null>(null);

	const renderer = ({ seconds }: { seconds: number }) => {
		return <span className={classes.btn__text}>({seconds}s)</span>;
	};

	const completed = () => {
		setIsBtnDisabled(false);
	};

	const sendConfirmCode = async () => {
		setIsBtnDisabled(true);
		setCountdown(Date.now() + 60_000);

		const userData = {
			user: user,
		};

		const res = await AuthApi.getConfirmCode(userData);
		if ('status' in res && res.status && res.status === 200) {
			setIsShowTitle(true);
		}
	};

	const onSubmit = async (formData: FormDataType) => {
		setToken?.(typeof formData.token === 'string' ? formData.token : '');

		const userData = Object.assign({}, { user: user }, formData);

		const res = await AuthApi.verifyConfirmCode(userData);
		if ('status' in res && res.status && res.status === 200) {
			navigate('/auth/new-password');
		} else {
			setResDataAfterSubmit(res?.data || res);
		}
	};

	useEffect(() => {
		setCountdown(Date.now() + 60_000);
	}, []);

	if (isAuth) {
		return <Navigate to='/' replace={true}></Navigate>;
	} else if (user === '') {
		return <Navigate to='/auth/recovery-password' replace={true} />;
	}

	const skeleton = {
		count: 3,
		style: {
			height: '36px',
		},
	};

	return (
		<div className={classes.container}>
			{isShowTitle && <span className={classes.titleForm}>Код отправлен</span>}
			<Form
				formId='codeForm'
				apiUrl={endpoints.confirmCode}
				classValueForm={classes.form}
				classValueBtn={classes.formBtn}
				btnText='Сменить пароль'
				onSubmit={onSubmit}
				skeleton={skeleton}
				resDataAfterSubmit={resDataAfterSubmit}
			>
				<>
					<span onClick={() => navigate('/auth')} className={classes.link}>
						Вернуться к авторизации
					</span>
					<button
						className={classes.btnSendCode}
						disabled={isBtnDisabled}
						onClick={() => sendConfirmCode()}
					>
						Отправить повторно &#160;
						{isBtnDisabled && (
							<Countdown
								date={countdown}
								renderer={renderer}
								onComplete={completed}
							/>
						)}
					</button>
				</>
			</Form>
		</div>
	);
};

export default AuthConfirmCode;
